import * as Sentry from '@sentry/browser'
import { onCLS, onINP, onLCP, onTTFB, type Metric } from 'web-vitals'

// DSN vem do ambiente (.env, fora do git). Sem DSN, Sentry fica desligado —
// dev local funciona sem conta Sentry.
export function initInstrumentation(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (dsn) {
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'production',
      release: __APP_VERSION__,
      tracesSampleRate: 0.1,
    })
  }

  const report = (metric: Metric): void => {
    if (dsn) {
      Sentry.setMeasurement(metric.name, metric.value, metric.name === 'CLS' ? '' : 'millisecond')
    }
    if (import.meta.env.DEV) {
      console.debug(`[web-vitals] ${metric.name}: ${metric.value.toFixed(2)} (${metric.rating})`)
    }
  }

  onLCP(report)
  onINP(report)
  onCLS(report)
  onTTFB(report)
}
